import React, {Component} from 'react'
// tabella contrassegni
import BackOfficeFiltersComponent from '../components/BackOfficeFiltersComponent'

import UserFormatter from '../components/grid-formatters/UserFormatter'
import ReactTable from 'react-table'
import PaymentMethodTypeFilter from '../components/ReactTable/Filters/PaymentMethodTypeFilter'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'


export default class BackOfficeReceiptScreen extends Component {
  constructor (props) {
    super(props)
    this.state = {
      columns: [
        {
          Header: 'ID Ricevuta',
          accessor: 'id',
          filterable: true,
          sortable: false,
          width: 80,
          Cell: (row) => {
            if( !row.original || !row.original.Order ) 
              return ( null )

            return (
              <div
                style={row.original.Order.MarkOrders.length > 0 && row.original.Order.MarkOrders[0].Mark && row.original.Order.MarkOrders[0].Mark.archived ? {textDecoration: 'line-through', color: '#a94442'} : null}
              >
                {row.value}

                {row.original.Order.MarkOrders.length > 0 && row.original.Order.MarkOrders[0].Mark && row.original.Order.MarkOrders[0].Mark.archived && (
                  <OverlayTrigger
                    overlay={
                      <Tooltip>
                        Questa ricevuta è collegata ad un contrassegno <b>eliminato</b>
                      </Tooltip>
                    }
                  >
                    <div style={{float: 'right', marginRight: '2px'}}>
                      <i className="glyphicon glyphicon-info-sign">{}</i>
                    </div>
                  </OverlayTrigger>
                )}
              </div>
            )
          }
        },
        {
          Header: '',
          accessor: 'Order',
          id: 'orderContentType',
          filterable: false,
          sortable: false,
          width: 140,
          Cell: (row) => {     
            if( !row.value  ) 
              return ( null )

            
            if (row.value.ParkTicketOrders.length > 0) {
              return (
                <span className="text-info">
                  ABBONAMENTO
                </span>
              )
            }

            if (row.value.MarkOrders.length > 0) {
              return (
                <span
                  className={row.value.MarkOrders[0].Mark && row.value.MarkOrders[0].Mark.archived ? 'text-danger' : 'text-primary'}
                  style={row.value.MarkOrders[0].Mark && row.value.MarkOrders[0].Mark.archived ? {textDecoration: 'line-through'} : null}
                >
                  CONTRASSEGNO
                </span>
              )
            }

            if (row.value.AdjustmentOrders.length > 0) {
              return (
                <span className="text-success">
                  PAGAMENTO 2018
                </span>
              )
            }

            return (<div>N.D</div>)
          }
        },
        {
          Header: 'Veicoli',
          accessor: 'Order',
          id: 'vehicles',
          filterable: false,
          sortable: false,
          minWidth: 200,
          Cell: (row) => {
            if (row.value && row.value.ParkTicketOrders && row.value.ParkTicketOrders.length > 0) {
              return (
                <div>
                  <span>
                    {`${row.value.ParkTicketOrders[0].ParkTicket.Vehicles.map((item, index) => {
                      let string = ''
                      string = string + item.plate_number
                      if (index < row.value.length - 1) {
                        string = string + ', '
                      }
                      return string
                    })}`}
                  </span>
                </div>
              )
            }

            if (row.value && row.value.MarkOrders && row.value.MarkOrders.length > 0) {
              return (
                <div
                  style={row.value.MarkOrders[0].Mark && row.value.MarkOrders[0].Mark.archived ? {textDecoration: 'line-through', color: '#a94442'} : null}
                >
                  <span>
                    {
                      row.value.MarkOrders && row.value.MarkOrders.map((mOrderItem, mOrderIndex) => {
                        if (!mOrderItem.Mark) {
                          return
                        }

                        return mOrderItem.Mark.Vehicles.map((item, index) => {
                          let string = ''
                          string = string + item.plate_number
                          if (index < row.value.length - 1) {
                            string = string + ', '
                          }
                          return string
                        })
                      })
                    }
                  </span>
                </div>
              )
            }

            if (row.value && row.value.AdjustmentOrders && row.value.AdjustmentOrders.length > 0) {
              return (
                <div>
                  <span>
                    {row.value.AdjustmentOrders.map((mOrderItem, mOrderIndex) => {
                      if (!mOrderItem.Adjustment) {
                        return
                      }

                      return mOrderItem.Adjustment.vehicle1 + ' ' +
                        (mOrderItem.Adjustment.vehicle2 || '') + ' ' +
                        (mOrderItem.Adjustment.vehicle3 || '')
                    })}
                  </span>
                </div>
              )
            }

            return (
              <div>N.D.</div>
            )
          }
        },
        {
          Header: 'Tipo',
          accessor: 'Order',
          id: 'orderContentMarkParkTicketType',
          filterable: false,
          sortable: false,
          minWidth: 200,
          Cell: (row) => {
            if (row.value && row.value.ParkTicketOrders.length > 0) {
              return (
                <div>
                  <span>
                    {`${row.value.ParkTicketOrders[0].ParkTicket.ParkTicketType.name} `}
                  </span>
                </div>
              )
            }

            if (row.value && row.value.MarkOrders.length > 0) {
              return (
                <div style={row.value.MarkOrders[0].Mark && row.value.MarkOrders[0].Mark.archived ? {textDecoration: 'line-through', color: '#a94442'} : null}>
                  <span>
                    {row.value.MarkOrders.map((mOrderItem, mOrderIndex) => {
                      if (!mOrderItem.Mark) {
                        return
                      }

                      return mOrderItem.Mark.MarkType.name + ' '
                    })
                    }
                  </span>
                </div>
              )
            }

            if (row.value && row.value.AdjustmentOrders.length > 0) {
              return (
                <div>
                  <span>
                    {row.value.AdjustmentOrders.map((mOrderItem, mOrderIndex) => {
                      if (!mOrderItem.Adjustment) {
                        return
                      }

                      return mOrderItem.Adjustment.mark1Type
                    })
                    }
                  </span>
                </div>
              )
            }

            return (
              <div>N.D.</div>
            )
          }
        },
        {
          Header: 'ID Contrassegno/Ricevuta',
          accessor: 'Order',
          id: 'orderContentId',
          filterable: false,
          sortable: false,
          width: 80,
          Cell: (row) => {
            if (row.value && row.value.ParkTicketOrders.length > 0) {
              return (
                <span>{`${row.value.ParkTicketOrders[0].ParkTicket.id} `}</span>
              )
            }

            if (row.value && row.value.MarkOrders.length > 0) {
              return (
                <span
                  style={row.value.MarkOrders[0].Mark && row.value.MarkOrders[0].Mark.archived ? {textDecoration: 'line-through', color: '#a94442'} : null}
                >
                  {
                    row.value.MarkOrders && row.value.MarkOrders.map((mOrderItem, mOrderIndex) => {
                      if (!mOrderItem.Mark) {
                        return
                      }

                      return mOrderItem.Mark.id + ' '
                    })
                  }
                </span>
              )
            }

            if (row.value && row.value.AdjustmentOrders.length > 0) {
              return (
                <span>
                  {
                    row.value.AdjustmentOrders && row.value.AdjustmentOrders.map((mOrderItem, mOrderIndex) => {
                      if (!mOrderItem.Adjustment) {
                        return
                      }

                      return mOrderItem.Adjustment.mark1 + ' ' +
                        (mOrderItem.Adjustment.mark2 || '') + ' ' +
                        (mOrderItem.Adjustment.mark3 || '')
                    })
                  }
                </span>
              )
            }

            return (<div>N.D.</div>)
          }
        },
        {
          Header: 'Totale',
          accessor: 'total',
          filterable: false,
          sortable: false,
          Cell: (row) => {
            if( !row.original || !row.original.Order  ) 
              return ( null )

            return (
              <div
                style={row.original.Order.MarkOrders.length > 0 && row.original.Order.MarkOrders[0].Mark && row.original.Order.MarkOrders[0].Mark.archived ? {textDecoration: 'line-through', color: '#a94442'} : null}
              >
                € {Number(row.value).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                </div>
            )
          }
        },
        {
          Header: 'Metodo di Pagamento',
          accessor: 'method',
          filterable: true,
          sortable: false,
          Cell: (row) => {
            if( !row.original || !row.original.Order  ) 
              return ( null )

            return (
              <div
                style={row.original.Order.MarkOrders.length > 0 && row.original.Order.MarkOrders[0].Mark && row.original.Order.MarkOrders[0].Mark.archived ? {textDecoration: 'line-through', color: '#a94442'} : null}
              >
                {row.value}
              </div>
            )
          },
          Filter: ({ filter, onChange }) => <PaymentMethodTypeFilter filter={filter} onChange={onChange} />
        },
        {
          Header: 'Nome',
          accessor: 'Order.User.firstName',
          filterable: true,
          sortable: false,
          Cell: (row) => {
            if( !row.original || !row.original.Order  ) 
              return ( null )

            return (
              <div
                style={row.original.Order.MarkOrders.length > 0 && row.original.Order.MarkOrders[0].Mark && row.original.Order.MarkOrders[0].Mark.archived ? {textDecoration: 'line-through', color: '#a94442'} : null}
              >
                {row.value}
              </div>
            )
          }
        },
        {
          Header: 'Cognome',
          accessor: 'Order.User.lastName',
          filterable: true,
          sortable: false,
          Cell: (row) => {
            if( !row.original || !row.original.Order  ) 
              return ( null )
              
            return (
              <div
                style={row.original.Order.MarkOrders.length > 0 && row.original.Order.MarkOrders[0].Mark && row.original.Order.MarkOrders[0].Mark.archived ? {textDecoration: 'line-through', color: '#a94442'} : null}
              >
                {row.value}
              </div>
            )
          }
        }
      ]
    }

    this.getTotalPages = this.getTotalPages.bind(this)
    this.onFetchData = this.onFetchData.bind(this)
  }

  onFetchData (state, instance) {
    let filterObj = {}
    for (let i in state.filtered) {
      let f = state.filtered[i]

      if (f.id === 'id') {
        filterObj['id'] = f.value
      }

      if (f.id === 'Order.User.firstName') {
        filterObj['firstName'] = f.value
      }

      if (f.id === 'Order.User.lastName') {
        filterObj['lastName'] = f.value
      }

      if (f.id === 'method') {
        filterObj['method'] = f.value
      }
    }

    let sortObj = {}
    for (let i in state.sorted) {
      let s = state.sorted[i]
      sortObj[s.id] = s.desc ? 'desc' : 'asc'
    }

    this.props.fetchReceipts(filterObj, state.pageSize, state.page)
  }

  getTotalPages () {
    const {pagination} = this.props

    if (!pagination) {
      return 0
    }

    if (pagination.total === 0) {
      return 0
    }

    return Math.ceil(pagination.total / pagination.limit)
  }

  render () {
    const {columns} = this.state
    return (<div>
      <ReactTable
        getTdProps={(state, rowInfo, column, instance) => {
          return {
            onClick: (e, handleOriginal) => {
              if (!rowInfo) {
                return
              }
              this.props.onRowClick(rowInfo.index, rowInfo.original)
            }}
        }}
        manual
        filterable
        loading={this.props.loading}
        noDataText={'Nessuna Ricevuta Presente'}
        onFetchData={this.onFetchData}
        pages={this.getTotalPages()}
        className="-highlight"
        data={this.props.receipts ? this.props.receipts : []}
        style={{maxHeight: '500px'}}
        defaultPageSize={100}
        nextText="Avanti"
        previousText="Indietro"
        loadingText="Caricamento in corso..."
        rowsText="elementi"
        ofText="di"
        pageText="Pagina"
        columns={columns} />
    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/screens/BackOfficeReceiptScreen.js